//@ts-nocheck
import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faTrash,
  faUndo,
} from '@fortawesome/free-solid-svg-icons';
import { removeMaterialFromCutting } from 'services/apiRequests/cutting/update';
import { setSpinner } from 'services/store/actions/view';
import ConfirmationModal from 'components/modals/ConfirmationModal';

const RemoveMaterialModal = ({
  cuttingPackage,
  materialIndex,
  material,
  closeModal,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);

  const handleRemove = async () => {
    setLoading(true);

    try {
      dispatch(setSpinner(true));
      await removeMaterialFromCutting(cuttingPackage._id, materialIndex);
      dispatch(setSpinner(false));

      alert.success(
        `Usunięto materiał: ${material.storageItem?.name} (przywrócono ${
          material.quantity
        } ${material.storageItem?.unit || 'szt.'} do magazynu)`,
      );

      if (onSuccess) onSuccess();
      closeModal();
    } catch (error) {
      dispatch(setSpinner(false));
      alert.error(
        error.response?.data?.message || 'Błąd podczas usuwania materiału',
      );
    } finally {
      setLoading(false);
    }
  };

  const materialName = material.storageItem?.name || 'Nieznany materiał';
  const materialQuantity = material.quantity;
  const materialUnit = material.storageItem?.unit || 'szt.';

  return (
    <ConfirmationModal
      closeModal={closeModal}
      title="Usuń materiał z cięcia"
      handleSubmit={handleRemove}
      submitButtonText={loading ? 'Usuwanie...' : 'Usuń materiał'}
      disabled={loading}
      description={
        <div>
          <div className="mb-3">
            <h6 className="text-muted mb-1">Materiał do usunięcia:</h6>
            <h5 className="mb-0">
              <FontAwesomeIcon icon={faWarehouse} className="me-2" />
              {materialName}
            </h5>
            <small className="text-muted">
              Ilość:{' '}
              <strong>
                {materialQuantity} {materialUnit}
              </strong>
            </small>
          </div>

          <Alert variant="warning" className="mb-3">
            <FontAwesomeIcon icon={faUndo} className="me-2" />
            <strong>Stan magazynowy zostanie przywrócony:</strong>
            <div className="mt-2">
              Do magazynu zostanie zwrócone{' '}
              <strong>
                {materialQuantity} {materialUnit}
              </strong>{' '}
              produktu "{materialName}".
            </div>
          </Alert>

          <p className="mb-0">
            Czy na pewno chcesz usunąć ten materiał z pakietu cięcia?
          </p>
        </div>
      }
    />
  );
};

export default RemoveMaterialModal;
